import _ from 'lodash';
import axios from 'axios';

const url = '/api/v1/lwadmin/score_weightings';

export function get() {
  return axios.get(url, { cache: { ignoreCache: true } });
}

export function update(sws) {
  return axios.post(url, {
    score_weightings: _.map(sws, x => ({
      id: x.id,
      multiplier: +x.multiplier,
    })),
  });
}
